import React from 'react'
import axios from 'axios'

import CanvasJSReact from './canvasjs/canvasjs.react'
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const initialState = {
	datas: {
		tipo: '',
		estado: '',
		fiscal: '',
		inicial: '',
		final: ''
	},
	list: [],
	info: {},
	clicked: false
}

export default class Estatisticas extends React.Component {
	constructor(props) {
		super(props)
		this.state = { ...initialState }
	}

	componentDidMount() {
		const url = '/api/user/getFiscais'
		axios(url)
			.then(resp => {
				this.setState({ list: [...resp.data] })
			})
			.catch(error => {
				alert(error.response.data)
			}
			)
	}

	updateField(event) {
		const data = this.state.datas
		data[event.target.name] = event.target.value
		this.setState({ datas: data })
	}

	buscar(e) {
		let tipo = this.state.datas.tipo
		const url = `/api/estatisticas/${tipo}`
		const datas = this.state.datas
		e.preventDefault()
		axios.post(url, datas)
			.then(resp => {
				this.setState({ info: resp.data })
				this.setState({ clicked: true })
			})
			.catch(error => {
				alert(error.response.data)
			})
	}

	render() {
		return (
			<React.Fragment>
				<div className="container form-group mx-auto row mt-3">
					<label className="col-2">Tipo:</label>
					<div className="col-10 col-md-4">
						<select className="custom-select"
							name="tipo"
							onChange={e => this.updateField(e)} >
							<option value=""></option>
							<option value="rotas">Diárias</option>
							<option value="efetivadas">Fiscalizações Realizadas</option>
							<option value="naoEfetivadas">Fiscalizações Não Realizadas</option>
							<option value="estabelecimento">Natureza Jurídica</option>
							<option value="administrativo">Processos Administrativos</option>
						</select>
					</div>
					<label className="col-2">Estado:</label>
					<div className="col-10 col-md-4">
						<select className="custom-select"
							name="estado"
							onChange={e => this.updateField(e)} >
							<option value=""></option>
							<option value="TODOS">Todos</option>
							<option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
						</select>
					</div>
				</div>
				<div className="container form-group mx-auto row mt-3" id="elemento">
					{this.renderCampo()}
				</div>
				<div className="container form-group mx-auto row mt-3">
					<label className="col-2">Inícial:</label>
					<div className="col-4">
						<input type="date" className="form-control"
							name="inicial"
							onChange={e => this.updateField(e)} />
					</div>
					<label className="col-2">Final:</label>
					<div className="col-4">
						<input type="date" className="form-control"
							name="final"
							onChange={e => this.updateField(e)} />
					</div>
					<div className="text-center mx-auto m-4">
						<button className="btn btn-success" onClick={e => this.buscar(e)}>Buscar</button>
					</div>
				</div>
				{this.renderChart()}
			</React.Fragment>
		)
	}

	renderFiscais() {
		let select = []
		this.state.list.map(ficha => {
			select.push(<option value={ficha.nome}>{ficha.nome}</option>)
		})
		return select
	}

	renderCampo() {
		if (this.state.datas.tipo !== 'administrativo') {
			return (
				<React.Fragment id="mutavel">
					<label className="col-2">Fiscal:</label>
					<div className="col-10 col-md-4">
						<select className="custom-select"
							name="fiscal"
							onChange={e => this.updateField(e)} >
							<option value=""></option>
							<option value="Todos">Todos Fiscais</option>
							{this.renderFiscais()}
						</select>
					</div>
				</React.Fragment>
			)
		}
	}

	renderChart() {
		if (this.state.datas.tipo == 'rotas') {
			var options = {
				animationEnabled: true,
				exportEnabled: false,
				theme: "light1", // "light1", "dark1", "dark2"
				title: {
					text: "ROTAS"
				},
				data: [{
					type: "pie",
					indexLabel: "{label}: {y}",
					startAngle: -90,
					dataPoints: [
						{ y: this.state.info.normal, indexLabel: "Sem Diária" },
						{ y: this.state.info.meia, indexLabel: "Meia Diária" },
						{ y: this.state.info.pernoite, indexLabel: "Pernoite" }
					]
				}]
			}
		}
		else if (this.state.datas.tipo == 'efetivadas') {
			var options = {
				animationEnabled: true,
				exportEnabled: false,
				theme: "light1", // "light1", "dark1", "dark2"
				title: {
					text: "FISCALIZAÇÕES REALIZADAS"
				},
				data: [{
					type: "pie",
					indexLabel: "{label}: {y}",
					startAngle: -90,
					dataPoints: [
						{ y: this.state.info.fisio, label: "Consultório Fisio" },
						{ y: this.state.info.to, label: "Consultório TO" },
						{ y: this.state.info.capsFisio, label: "Caps Fisioterapia" },
						{ y: this.state.info.capsTO, label: "Caps TO" },
						{ y: this.state.info.clinicaFisio, label: "Clínica Fisioterapia" },
						{ y: this.state.info.clinicaTO, label: "Clínica TO" },
						{ y: this.state.info.nasfFisio, label: "NASF Fisioterapia" },
						{ y: this.state.info.nasfTO, label: "NASF TO" },
						{ y: this.state.info.ilegal, label: "Ilegal" },
						{ y: this.state.info.social, label: "Rede Social" },
						{ y: this.state.info.ilpiFisio, label: "Ilpi Fisioterapia" },
						{ y: this.state.info.ilpiTO, label: "Ilpi TO" },
						{ y: this.state.info.hospitalFisio, label: "Hospital Fisioterapia" },
						{ y: this.state.info.hospitalTO, label: "Hospital TO" },
						{ y: this.state.info.branco, label: "Em Branco" },
					]
				}]
			}
		}
		else if (this.state.datas.tipo == 'naoEfetivadas') {
			var options = {
				animationEnabled: true,
				exportEnabled: false,
				theme: "light1", // "light1", "dark1", "dark2"
				title: {
					text: "FISCALIZAÇÕES NÃO REALIZADAS"
				},
				data: [{
					type: "pie",
					indexLabel: "{label}: {y}",
					startAngle: -90,
					dataPoints: [
						{ y: this.state.info.fechado, label: "Estabelecimento Fechado" },
						{ y: this.state.info.desativado, label: "Estabelecimento Desativado" }
					]
				}]
			}
		}
		else if (this.state.datas.tipo == 'estabelecimento') {
			var options = {
				animationEnabled: true,
				exportEnabled: false,
				theme: "light1", // "light1", "dark1", "dark2"
				title: {
					text: "TIPOS DE ESTABELECIMENTO"
				},
				data: [{
					type: "pie",
					indexLabel: "{label}: {y}",
					startAngle: -90,
					dataPoints: [
						{ y: this.state.info.privado, label: "Privado" },
						{ y: this.state.info.publico, label: "Público" },
						{ y: this.state.info.filantropico, label: "Filantrópico" }
					]
				}]
			}
		}

		else if (this.state.datas.tipo == 'administrativo') {
			var options = {
				animationEnabled: true,
				exportEnabled: false,
				theme: "light1", // "light1", "dark1", "dark2"
				title: {
					text: "PROCESSOS ADMINISTRATIVOS"
				},
				data: [{
					type: "pie",
					indexLabel: "{label}: {y}",
					startAngle: -90,
					dataPoints: [
						{ y: this.state.info.revisita, label: "Revisita" },
						{ y: this.state.info.arquivo, label: "Arquivo" },
						{ y: this.state.info.prazo, label: "Aguardando prazo" },
						{ y: this.state.info.etico, label: "Processo Ético" },
						{ y: this.state.info.presidencia, label: "Presidência" },
						{ y: this.state.info.coordenacao, label: "Coordenação" },
						{ y: this.state.info.novo, label: "Novo" },
						{ y: this.state.info.juridico, label: "Assessoria Jurídica" },
						{ y: this.state.info.administrativo, label: "Administrativo" },
						{ y: this.state.info.noticiaCrime, label: "AJUR Contencioso Notícia Crime" },
						{ y: this.state.info.diversos, label: "AJUR Contencioso Diversos" }
					]
				}]
			}
		}

		if (this.state.clicked) {
			return (
				<div>
					<div className="container mx-auto m-4">
						<CanvasJSChart options={options} />
					</div>
				</div>
			);
		}
	}
}